<template>
  <div>
    <CRow class="mt-4">
      <CCol md="12">
        <CCard>
          <CCardHeader color="light" class="d-inline-flex justify-content-between align-items-center">
            <div>
              <i class="fa fa-tachometer"></i>
              <strong> Báo cáo thống kê </strong>
            </div>
            <CButton color="primary" class="text-right" @click="loadDataStatisticDeviceFiles()">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp;Tải lại
            </CButton>
          </CCardHeader>
          <CCardBody>
            <CRow v-if="statistic != null && statistic != undefined">
              <CCol md="6">
                <CCard>
                  <CCardHeader color="light">
                    <i class="fa fa-file"></i>
                    <strong> Số lượng bản tin phát thanh </strong>
                    <strong>({{ statistic.audioFile.total }})</strong>
                  </CCardHeader>
                  <CCardBody class="row text-center">
                    <div class="col" style="color: #000000!important">
                      <div class="text-value-lg">
                        {{ statistic.audioFile.total }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Tổng
                      </div>
                    </div>
                    <div class="c-vr"></div>
                    <div class="col" style="color: #fa8a00!important">
                      <div class="text-value-lg">
                        {{ statistic.audioFile.totalPlaying || 0 }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Đang phát
                      </div>
                    </div>
                    <div class="c-vr"></div>
                    <div class="col" style="color: #1bbf1b!important">
                      <div class="text-value-lg">
                        {{ statistic.audioFile.totalBroadcast || 0 }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Đã phát
                      </div>
                    </div>
                  </CCardBody>
                </CCard>
              </CCol>
              <CCol md="6">
                <CCard>
                  <CCardHeader color="light">
                    <i class="fa fa-file"></i>
                    <strong> Số lượng bản tin màn hình điện tử </strong>
                    <strong>({{ statistic.screenFile.total }})</strong>
                  </CCardHeader>
                  <CCardBody class="row text-center">
                    <div class="col" style="color: #000500!important">
                      <div class="text-value-lg">
                        {{ statistic.screenFile.total || 0 }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Tổng
                      </div>
                    </div>
                    <div class="c-vr"></div>
                    <div class="col" style="color: #fa8a00!important">
                      <div class="text-value-lg">
                        {{ statistic.screenFile.totalPlaying || 0 }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Đang phát
                      </div>
                    </div>
                    <div class="c-vr"></div>
                    <div class="col" style="color: #1bbf1b!important">
                      <div class="text-value-lg">
                        {{ statistic.screenFile.totalBroadcast || 0 }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Đã phát
                      </div>
                    </div>
                  </CCardBody>
                </CCard>
              </CCol>
              <CCol md="6">
                <CCard>
                  <CCardHeader color="light">
                    <i class="fa fa-bullhorn"></i>
                    <strong> Số lượng loa phát thanh </strong>
                    <strong>({{ statistic.audioDevice.total }})</strong>
                  </CCardHeader>
                  <CCardBody class="row text-center">
                    <div class="col" style="color: #1bbf1b!important">
                      <div class="text-value-lg">
                        {{ statistic.audioDevice.statusActive || 0 }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Đang hoạt động
                      </div>
                    </div>
                    <div class="c-vr"></div>
                    <div class="col" style="color: red!important">
                      <div class="text-value-lg">
                        {{ statistic.audioDevice.statusInactive || 0 }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Không hoạt động
                      </div>
                    </div>
                    <div class="c-vr"></div>
                    <div class="col" style="color: #1bbf1b!important">
                      <div class="text-value-lg">
                        {{ statistic.audioDevice.connectActive || 0 }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Đang kết nối
                      </div>
                    </div>
                    <div class="c-vr"></div>
                    <div class="col" style="color: red!important">
                      <div class="text-value-lg">
                        {{ statistic.audioDevice.connectInactive || 0 }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Mất kết nối
                      </div>
                    </div>
                  </CCardBody>
                </CCard>
              </CCol>
              <CCol md="6">
                <CCard>
                  <CCardHeader color="light">
                    <i class="fa fa-desktop"></i>
                    <strong> Số lượng màn hình điện tử </strong>
                    <strong>({{ statistic.screenDevice.total }})</strong>
                  </CCardHeader>
                  <CCardBody class="row text-center">
                    <div class="col" style="color: #1bbf1b!important">
                      <div class="text-value-lg">
                        {{ statistic.screenDevice.statusActive || 0 }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Đang hoạt động
                      </div>
                    </div>
                    <div class="c-vr"></div>
                    <div class="col" style="color: red!important">
                      <div class="text-value-lg">
                        {{ statistic.screenDevice.statusInactive || 0 }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Không hoạt động
                      </div>
                    </div>
                    <div class="c-vr"></div>
                    <div class="col" style="color: #1bbf1b!important">
                      <div class="text-value-lg">
                        {{ statistic.screenDevice.connectActive || 0 }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Đang kết nối
                      </div>
                    </div>
                    <div class="c-vr"></div>
                    <div class="col" style="color: red!important">
                      <div class="text-value-lg">
                        {{ statistic.screenDevice.connectInactive || 0 }}
                      </div>
                      <div class="text-uppercase text-muted small">
                        Mất kết nối
                      </div>
                    </div>
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="3">
                <CCard v-if="statistic">
                  <CCardHeader color="light">
                    <i class="fa fa-user"></i>
                    <strong> Tài khoản </strong>
                    <small>theo chức vụ</small>
                  </CCardHeader>
                  <CCardBody>
                    <CListGroup v-if="statistic.users.length > 0">
                      <CListGroupItem v-for="user in statistic.users" :key="user.name"
                                      class="d-flex justify-content-between align-items-center">
                        <strong>{{ user.name }}</strong>
                        <CBadge color="light" shape="pill" style="font-size: 13px">{{ user.total }}</CBadge>
                      </CListGroupItem>
                    </CListGroup>
                    <div v-else class="d-flex justify-content-center align-items-center">
                      <span>Không có dữ liệu</span>
                    </div>
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseFormLoading from "@/views/base/BaseFormLoading";

export default {
  name: 'Dashboard',
  components: {BaseFormLoading},
  data() {
    return {
      loading: {value: false},
      statisticUser: [],
      statistic: null
    }
  },
  created() {
  },
  mounted() {
    this.loadDataStatisticDeviceFiles();
  },
  methods: {
    loadDataStatisticDeviceFiles: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/dashboard/statistic",
        dataSubmit() {
          return {}
        },
        ignoreDefaultData: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.statistic = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  computed: {},
}
</script>
